import { RocketIcon } from 'lucide-react';

export function NewVersionBanner() {
  return (
    <div
      id='new-version-banner'
      className='text-sm relative z-1000 text-white p-2 text-center hidden justify-center items-center top-0 inset-x-0 bg-secondary-1000 gap-2'
    >
      <RocketIcon size={20} />
      <span>
        <strong>New version available.</strong> Please refresh to update.
      </span>

      <button
        onClick={() => window.location.reload()}
        className='hover:bg-white/10 underline cursor-pointer px-2 py-[2px] rounded-sm'
      >
        Reload
      </button>
    </div>
  );
}
